
import React from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState, useEffect } from "react";
import { faAddressBook, faIdCard, faPhone, faFile, faBuilding, faUser, faCalendar } from "@fortawesome/free-solid-svg-icons";
import { Col, Row, Form, Card, Button, Badge, Container, InputGroup } from '@themesberg/react-bootstrap';
import { dashboardUser, dashboardUserFiles } from "../../api/services";

export default (data) => {
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [dob, setDob] = useState();
  const [dlNumber, setDlNumber] = useState("");
  const [dlFilePreview, setDlFilePreview] = useState("");
  const [dlIssueDate, setDlIssueDate] = useState();
  const [dlExpiryDate, setDlExpiryDate] = useState();
  const [address, setAddress] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isActive, setIsActive] = useState(false);
  const [createdAt, setCreatedAt] = useState("");
  const [updatedAt, setUpdatedAt] = useState("");
  const [altphoneNumber, setAltPhoneNumber] = useState("");
  const formatDate = (isoDate) => {
    const date = new Date(isoDate);

    return date.toLocaleString("en-IN", {
      day: "numeric",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };
  useEffect(() => {
    const fetchData = async () => {
      setShowLoader(true);
      try {
        const d = data?.data?.driver;
        if (d) {
          console.log("Received driver data:", d);
          setFirstName(d.first_name || "");
          setLastName(d.last_name || "");
          setPhoneNumber(d.phone || "");
          setDlNumber(d.dl_num || "");
          setAddress(d.address || "");
          setIsActive(d.is_active || false);
          setCreatedAt(formatDate(d.created_at));
          setUpdatedAt(formatDate(d.updated_at));
          setDlExpiryDate(formatDate(d.dl_expiry_date));
          setDlIssueDate(formatDate(d.dl_issue_date));
          setDob(formatDate(d.dob));
          setAltPhoneNumber(d.alt_phone || "");
          console.log("Driver Name:", d.first_name, d.last_name);
          const _dlfile = await dashboardUserFiles(null, 102);
          console.log("DL FILE RAW:", _dlfile);
          if (_dlfile && _dlfile.size > 0) {
            setDlFilePreview(URL.createObjectURL(_dlfile));
          } else {
            setDlFilePreview("");
            console.log("DL file is empty or null");
          }
        }
      } catch (error) {
        console.error("Error fetching driver details:", error);
      } finally {
        setShowLoader(false);
      }
    };
    fetchData();
  }, [data]);


  return (
    <main>
      {/* <Preloader show={showLoader} /> */}
      <Container className="px-0" style={{ backgroundColor: `#ffffff` }}>
        <section className="d-flex align-items-center my-5 mt-lg-2 mb-lg-2" >
          <Container>
            <div className="d-flex justify-content-between align-items-center mb-3">
              <h5 className="mb-0">Profile Details</h5>

              <Badge bg={isActive ? "success" : "warning"}>
                {isActive ? "Active" : "Inactive"}
              </Badge>
            </div>

            <Row className="g-3">
              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faUser} className="me-2 text-gray-700" />
                  <strong>Name :</strong>
                  <div className="text-muted text-primary">{firstName} {lastName}</div>
                </div>
              </Col>

              

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faCalendar} className="me-2 text-gray-700" />
                  <strong>DOB:</strong>
                  <div className="text-muted text-primary">{dob || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faPhone} className="me-2 text-gray-700" />
                  <strong>Phone:</strong>
                  <div className="text-muted text-primary">{phoneNumber || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faPhone} className="me-2 text-gray-700" />
                  <strong>Alternate Phone:</strong>
                  <div className="text-muted text-primary">{altphoneNumber || "-"}</div>
                </div>
              </Col>


              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faIdCard} className="me-2 text-gray-700" />
                  <strong>DL Number:</strong>
                  <div className="text-muted text-primary">{dlNumber || "-"}</div>
                </div>
              </Col>

              

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faIdCard} className="me-2 text-gray-700" />
                  <strong>DL Issue Date:</strong>
                  <div className="text-muted text-primary">{dlIssueDate || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faIdCard} className="me-2 text-gray-700" />
                  <strong>DL Expiry Date:</strong>
                  <div className="text-muted text-primary">{dlExpiryDate || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faIdCard} className="me-2 text-gray-700" />
                  <strong>DL Preview: </strong>
                  {dlFilePreview ? (
                    <a href={dlFilePreview} target="_blank" rel="noopener noreferrer">
                      📄 View
                    </a>
                  ) : "-"}
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faAddressBook} className="me-2 text-primary" />
                  <strong>Address:</strong>
                  <div className="text-muted">{address || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faFile} className="me-2 text-primary" />
                  <strong>Created At:</strong>
                  <div className="text-muted">{createdAt || "-"}</div>
                </div>
              </Col>

              <Col md={6}>
                <div className="profile-item">
                  <FontAwesomeIcon icon={faFile} className="me-2 text-primary" />
                  <strong>Updated At:</strong>
                  <div className="text-muted">{updatedAt || "-"}</div>
                </div>
              </Col>

            </Row>
          </Container>
        </section>
      </Container>
      {/* </Container> */}


    </main>
  );
};
